import React from 'react'
import './Transmission.css'

const Transmission = () => {
  return (
    <div>
      <div className="transmissionp">
        <p className="p">Transmission Chain</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Transmission Chain</p> */}
        </div>
      </div>

      <div className='trbody'>

      </div>

    {/* <div className="transmission">
      <div className="trimg">
        <figure>
          <img src={} alt="Range Attachment"/>
          <figcaption>Range Attachment Ring</figcaption>
        </figure>
      </div>

      <div className="trimg">
        <figure>
          <img src={} alt="Range Attachment"/>
          <figcaption>Range Forging Links</figcaption>
        </figure>
      </div>

      <div className="trimg">
        <figure>
          <img src={} alt="Range Attachment"/>
          <figcaption>Range Ring</figcaption>
        </figure>
      </div>
      </div> */}


    </div>
  )
}

export default Transmission
